import * as React from "react";
import { DiscountInfoBox } from "./styles";
import CountDown from "../../CountDown";
export default class DiscountInfoCard extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.getStyle = (item) => {
            return { height: (item === null || item === void 0 ? void 0 : item.height) || "auto" };
        };
        this.renderImgOnTopLeft = () => {
            var _a;
            if ((_a = this.props.discountInfo) === null || _a === void 0 ? void 0 : _a.img) {
                return (React.createElement("img", { className: "discountIcon", src: this.props.discountInfo.img, alt: "", style: this.getStyle(this.props.discountInfo) }));
            }
            return null;
        };
        this.renderImgOnTopRight = () => {
            var _a;
            if ((_a = this.props.tagInfo) === null || _a === void 0 ? void 0 : _a.img) {
                return (React.createElement("img", { className: "descImg", src: this.props.tagInfo.img, alt: "", style: this.getStyle(this.props.tagInfo) }));
            }
            return null;
        };
        this.renderImgOnBottomLeft = () => {
            var _a;
            if ((_a = this.props.themeTag) === null || _a === void 0 ? void 0 : _a.img) {
                return React.createElement("img", { className: "themeTag", src: this.props.themeTag.img, alt: "" });
            }
            return null;
        };
    }
    render() {
        const { discountInfo, tagInfo, themeTag, className = "", flash } = this.props;
        if (!discountInfo && !tagInfo && !themeTag) {
            return null;
        }
        return (React.createElement(DiscountInfoBox, { className: `${className}` },
            this.renderImgOnTopLeft(),
            this.renderImgOnTopRight(),
            this.renderImgOnBottomLeft(),
            (flash === null || flash === void 0 ? void 0 : flash.countdownToEnd) && React.createElement(CountDown, { countInfo: flash })));
    }
}
